import type { TranslationSchema } from '../pt-BR';
import type { DeepPartialStrings } from '../types';

export const validation = {
    required: {
        name: 'Name is required',
        date: 'Date is required',
        description: 'Description is required',
        startDate: 'Start date is required',
        amount: 'Amount is required',
    },
    amount: {
        positive: 'Amount must be greater than zero',
        monthlyPositive: 'Monthly amount must be greater than zero',
        installmentPositive: 'Installment amount must be greater than zero',
    },
    select: {
        account: 'Select an account',
        category: 'Select a category',
        card: 'Select a card',
        destinationAccount: 'Select the destination account',
        paymentAccount: 'Select the payment account',
    },
    installments: {
        min: 'At least 2 installments',
        max: 'Maximum of 48 installments',
    },
    creditCard: {
        limitPositive: 'Limit must be positive',
    },
    budget: {
        name: 'Give the budget a name',
        selectCategory: 'Select at least one category',
    },
    goal: {
        target: 'Target amount is required',
        targetForMeta: 'Target amount is required for a goal',
    },
    reserva: {
        selectAccount: 'Choose the pocket account',
    },
    financing: {
        totalInstallments: 'Enter the total number of installments',
        nextInstallment: 'Enter the next installment',
        nextDueDate: 'Next due date is required',
        outstandingPositive: 'Outstanding balance must be positive',
        nextGtTotal: 'The next installment cannot be greater than the total',
        contractName: 'Enter the contract name',
        rateRequiredForSac: 'Enter the contract rate (per year) to use declining instalments',
        balanceRequiredForSac: 'Enter the outstanding balance to compute declining instalments',
        rateTooHigh: 'The contract rate is per year, at most 100 — check the decimal separator',
    },
    prepayment: {
        amountPositive: 'Paydown amount must be greater than zero',
        remainingNonNegative: 'Remaining installments must be zero or more',
        newMonthlyNonNegative: 'Installment amount must be zero or more',
        newOutstandingNonNegative: 'Outstanding balance must be zero or more',
        remainingRequired: 'Enter how many installments remain after the paydown',
        newMonthlyRequired: 'Enter the new installment amount',
    },
} satisfies DeepPartialStrings<TranslationSchema['validation']>;
